<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<MessageNewDialog
					:message="message"
					:message_templates="message_templates"
					:departments="departments"
					:requirement_types="requirement_types"
					text
				/>
				<MessageTemplateNewDialog text @new-message-template="addMessageTemplate($event)" />
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<MessageNewDialog
					:message="message"
					:message_templates="message_templates"
					:departments="departments"
					:requirement_types="requirement_types"
				/>
				<MessageTemplateNewDialog @new-message-template="addMessageTemplate($event)" />
			</template>

			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="messages"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					@click:row="showDialog"
				>
					<template v-slot:[`item.content`]="{ value }">
						<div class="text-truncate" style="max-width: 150px">
							{{ value }}
						</div>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<MessageShowDialog v-if="selectedItem" :item="selectedItem" @close="selectedItem = null" />
	</v-sheet>
</template>

<script>
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import axios from "axios"

import PaginationModule from "../shared/PaginationModule.vue"
import MessageShowDialog from "./components/MessageShowDialog.vue"
import MessageNewDialog from "./components/MessageNewDialog.vue"
import MessageTemplateNewDialog from "./components/MessageTemplateNewDialog.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		PaginationModule,
		CommonFlame,
		FunctionTitle,
		MessageShowDialog,
		MessageNewDialog,
		MessageTemplateNewDialog,
	},
	data() {
		return {
			mainTitle: "お知らせ",
			pageTitle: "メッセージ一覧",
			id: this.$route.params["id"],
			user: null,
			type: "message",
			selectedItem: null,
			message: {
				title: "",
				content: "",
				image: null,
				fileData: {
					type: "",
					fileName: "",
				},
				matter: "",
				user_name: "",
				selectedDepartmentId: "",
				selectedUser: "",
				selectedMessageTemplateId: "",
				selectedRequirementTypeId: "",
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "タイトル", value: "title", width: "200px" },
				{ text: "内容", value: "content", width: "200px" },
				{ text: "時刻", value: "datetime_ja", width: "200px" },
				{ text: "", value: "read_flag_ja", width: "200px" },
			],
			messages: [],
			message_templates: [],
			departments: [],
			requirement_types: [],
			changeFlagMessage: "",
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchMessages()
	},
	methods: {
		addMessageTemplate(e) {
			this.message_templates.push(e)
		},
		showDialog(item) {
			// if (!item.url) {
			// 	this.selectedItem = item
			// } else {
			// 	this.$router.push({ path: item.url })
			// }
			this.selectedItem = item
			this.readMessage(item.id)
		},
		readMessage(id) {
			const message = this.messages.find((message) => message.id == id)
			if (message.read_flag_ja == "既読") return
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/messages/${id}`, { headers })
				.then((res) => {
					this.changeFlagMessage = message
					this.changeFlagMessage.read_flag_ja = "既読"
					this.$store.commit("reduceMessageCount")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/messages", {
					params: { page: i, type: this.type },
					headers,
				})
				.then((res) => {
					this.messages = res.data.messages
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		fetchMessages() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/messages`, { headers, params: { type: this.type } })
				.then((res) => {
					this.messages = res.data.messages
					this.pagination = res.data.pagination
					this.message_templates = res.data.message_templates
					this.departments = res.data.departments
					this.requirement_types = res.data.requirement_types
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
